<template>
    <div
        class="flex items-center justify-center rounded-full bg-primary-gradient text-white transition-colors"
        :class="[ big ? 'min-w-15 min-h-15 max-w-15 max-h-15' : 'min-w-8.5 min-h-8.5 max-h-8.5 max-w-8.5' ]"
    >
        <UserIcon :class="[ big ? 'w-12 h-12' : 'w-6 h-6' ]" />
    </div>
</template>

<script setup>
import UserIcon from '@/components/icons/navigations/UserIcon.vue'

defineProps({
    big: {
        type: Boolean,
        default: false,
    },
})
</script>
